import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../common/data.service';
import { AppTokenHandler } from '../../common/app-token-handler';
import { AlertService } from '../../common/alert.service';
// import { MsalService } from '@azure/msal-angular';
import { AzureAuthService } from '../../common/azure-auth.service';
import { catchError, takeUntil } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    private token!: string;
    private azure_token: any = '';
    private readonly _destroying$ = new Subject<void>();

    constructor(private appToken: AppTokenHandler,
        private gservice: DataService,
        // private msalService: MsalService,
        private route: Router,
        private alertService: AlertService,
        private _azureAuthService: AzureAuthService) { }
    ngOnInit() {
        /*var account = this.msalService.getAccount();
        if (account) {
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
            };

            this.msalService.acquireTokenPopup(accessTokenRequest).then((res) => {
                console.log("acquireTokenPopup");
                this.token = res.accessToken;
                this.GetUserDetails(this.token);

            }).catch((e) => {
                console.log("acquireTokenPopup catch");
                console.log(e);
            });
        }*/
        if (this.appToken.getSessionToken().length <= 0) {
            this.acquireAzureToken();
        } else {
            this.route.navigate(['/home']);
        }
    }

    async acquireAzureToken() {
        this._azureAuthService.handleQueryParameters()
            .pipe(
                takeUntil(this._destroying$),
                catchError(error => {
                    return throwError(() => error);
                })
            )
            .subscribe({
                next: (result) => {
                    if (result) {
                        this.azure_token = result;
                        this.appToken.setAzureTokenInCookie(result);
                        console.log('Azure token acquired: ', this.azure_token);
                        this.GetUserDetails(result);
                    }
                }
            });
    }

    GetUserDetails(token) {
        if (this.appToken.getSessionToken().length <= 0) {
            this.gservice.LoginWithToken(token).subscribe((data: any) => {
                this.appToken.setCookie('access_token',data.access_token,1)
                this.appToken.setSessionToken(data);
                console.log(this.appToken.getRedirectTo());
                //this.route.navigate([''+this.appToken.getRedirectTo()+'']);
                let url = this.appToken.getRedirectTo();
                this.route.navigate([url]);
                //this.route.navigate(['/home']);
            },
                (error: Response) => {
                    if (error.status <= 0) {
                        this.route.navigate(['/badrequest']);
                    }
                    else if (error.status == 401) {
                        this.route.navigate(['/unauthorize']);
                    }
                    else {
                        this.alertService.notify('error', 'Server Error', error.statusText);
                    }
                });
        }
        else {
            this.route.navigate(['/home']);
        }
    };
}
